export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./form-reviews.vue?vue&type=template&id=eb9b6048&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/forms/form-reviews.vue?vue&type=template&id=eb9b6048&
// module id = 1245
// module chunks = 0